import { setSessionTimeout } from "../redux/Auth/actionCreator";
import { api } from "../Services/api";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

// export const useFetch = (
//   queryKey,
//   url,
//   onSuccess,
//   onError,
//   interval = false,
//   enabled = false,
//   select,
//   initialData
// ) => {
//   const dispatch = useDispatch()

//   return useQuery(
//     [queryKey],
//     async () => {
//       return await api
//         .get(url, {
//           headers: {
//             authorizationToken: localStorage.getItem("token"),
//             loadall: true
//           }
//         })
//         .then((res) => {
//           return res.data
//         })
//         .catch((err) => {
//           if (err.response.status === 401) {
//             // 401 is the status code for session timeout
//             dispatch(setSessionTimeout(true))
//             // dispatch(userLogout())
//           }
//         })
//     },
//     {
//       refetchInterval: interval,
//       onSuccess,
//       onError,
//       // cacheTime: 30000,
//       enabled,
//       refetchOnWindowFocus: false,
//       refetchOnMount: true,
//       select: select,
//       initialData: initialData
//     }
//   )
// }

// Workflows deleted while their tasks still use them (missingId -> fallbackId).
// The missing id is served as a read-only copy so task statuses resolve.
const WORKFLOW_FALLBACKS = {
  defaultWAX671O47: "19151", // Insyts
};

const applyWorkflowFallbacks = (data) => {
  const workflowList = data?.data?.workflowList;
  if (!workflowList) return;
  for (const [missingId, fallbackId] of Object.entries(WORKFLOW_FALLBACKS)) {
    const fallback = workflowList[fallbackId];
    if (workflowList[missingId] || !Array.isArray(fallback)) continue;
    workflowList[missingId] = fallback.map((wf) => ({
      ...wf,
      workFlowId: missingId,
      isAlias: true,
      aliasOf: fallbackId,
    }));
  }
};

export const useFetch = (
  queryKey,
  url,
  onSuccess,
  onError,
  interval = false,
  enabled = false,
  select,
  initialData,
) => {
  const dispatch = useDispatch();

  return useQuery(
    queryKey,
    async () => {
      try {
        const res = await api.get(url, {
          headers: {
            authorizationToken: localStorage.getItem("token"),
            loadall: true,
          },
        });
        if (url === "/trekrworkflow") applyWorkflowFallbacks(res.data);
        return res.data;
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch(setSessionTimeout(true));
        }
        throw err;
      }
    },
    {
      refetchInterval: interval,
      onSuccess,
      onError,
      enabled,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      select,
      initialData,
    },
  );
};
